export default "__VITE_ASSET__9798e979__"